import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A careless rant about human rights",
  "description": "",
  "published": "2009-12-10T00:00:00.000Z",
  "redirect_from": ["/blog/a-careless-rant-about-human-rights/swizec/953"],
  "categories": "food for thought, Human Rights and Liberties, humanrights, intrigues, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:FatherChristmastrial.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/FatherChristmastrial.jpg",
              "alt": "Excerpt from Josiah King's The Examination and...",
              "title": "Excerpt from Josiah King's The Examination and..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:FatherChristmastrial.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Today is supposedly `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Human_rights",
        "title": "Human rights"
      }}>{`human rights`}</a>{` day, a celebration so empty and void of any consequental meaning as Christmas, Birthdays and any other arbitrary date and/or event people decide to celebrate.`}</p>
    <p>{`Besides, every day is a day of something and it's getting kinda old, what when new 'days' need adding? We're going to do special days on a fiscal year that lasts 1.6732 years instead of 1.0 years like it does now?`}</p>
    <p>{`Nigga please.`}</p>
    <p>{`There you go `}<a parentName="p" {...{
        "href": "http://twitter.com/anca_foster"
      }}>{`@anca_foster`}</a>{`, I ranted absolutely carelessly about human rights day. You can thank me later.`}</p>
    <p>{`This post brought to you from the special department of sleepiness, tardiness and general mehness about the current big important thing(tm).`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/b1459153-a9fe-4a6e-afb9-3509c9d0d147/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=b1459153-a9fe-4a6e-afb9-3509c9d0d147",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      